import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";
import "./leaveorgin.css";
import Swal from "sweetalert2";
import axios from "axios";
import {
  GetRestrictedDate,
  CreateRestrictedDate,
  DeleteRestrictedDate,
  HEADERS,
  getsetId,
} from "../../api";

export default function AddRestrictedDate() {
  const [buttonClicked, setButtonClicked] = useState(false);
  const [RestrictedDate, setRestrictedDate] = useState([]);
  const [leaveRemarks, setLeaveRemarks] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(0);
  const handleLeaveRemarksChange = (e) => {
    const leaveRemarks = e.target.value;
    setLeaveRemarks(leaveRemarks);
  };

  const Restricated_Date = async () => {
    setButtonClicked(true);
    const { value: formValues, isConfirmed } = await Swal.fire({
      title: "Add Restricted Date",
      showCancelButton: true,
      confirmButtonText: "Add",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      customClass: {
        confirmButton: "swal-custom-confirm-btn",
        cancelButton: "swal-custom-cancel-btn",
      },
      html: `
          <div class="p-2 d-flex flex-column gap-2">
            <div class="d-flex flex-column">
              <small class="text-start">Restricted Date</small>
              <input id="Restricted" class="form-control mt-1" type="date" placeholder="Enter Restricted Date"  autofocus>

            </div>
            <div class="d-flex flex-column">
              <small class="text-start">Description</small>
              <input id="leaveRemarks" class="form-control mt-1" type="text" placeholder="Enter description"  autofocus>
            </div>
        </div>

      `,
      preConfirm: async () => {
        const Restricted = Swal.getPopup().querySelector("#Restricted").value;
        const leaveRemarks =
          Swal.getPopup().querySelector("#leaveRemarks").value;

        if (!Restricted || !leaveRemarks) {
          Swal.showValidationMessage("Please fill in all the fields");
          return { success: false, message: "Please fill in all the fields" };
        }

        const setId = getsetId();
        const requestBody = {
          set_id: setId,
          restricted_date: Restricted,
          restricted_reason: leaveRemarks,
        };

        console.log("Sending Request Body:", requestBody);

        try {
          const response = await fetch(CreateRestrictedDate, {
            method: "POST",
            headers: HEADERS,
            body: JSON.stringify(requestBody),
          });
          const result = await response.json();
          if (response.ok && result.response_code === "0000") {
            setRestrictedDate((prev) => [...prev, result.data || requestBody]);
            return { success: true, message: result.response_description };
          } else {
            return { success: false, message: result.response_description };
          }
        } catch (error) {
          console.error("Error during Adding Restricted Date:", error);
          return { success: false, message: "Network error or server error" };
        }
      },
    });

    if (isConfirmed) {
      const { success, message } = formValues;
      Swal.fire({
        title: success ? "Added!" : "Failed!",
        text: message,
        icon: success ? "success" : "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#2D7D9F",
      }).then((result) => {
        window.location.reload();
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const SetID = getsetId();

      try {
        const requestData = { set_id: SetID };
        const response = await axios.post(GetRestrictedDate, requestData, {
          headers: HEADERS,
        });
        console.log("respons:::::::::::::::::::::", response.data);

        if (response.data.response_code === "0000") {
          setRestrictedDate(response.data.data);
        } else {
          console.error(
            "Error fetching restricted date. Please try again later."
          );
        }
      } catch (error) {
        console.error("An error occurred while Restricted Date:", error);
      }
    };

    fetchData();
  }, []);

  const handleDelete = async (DateID) => {
    try {
      if (!DateID) {
        console.error("Missing DateID for deletion");
        return;
      }

      const confirmDelete = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover the restricted date.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });

      if (confirmDelete.isConfirmed) {
        const payload = { date_id: DateID };
        const response = await axios.post(DeleteRestrictedDate, payload, {
          headers: {
            "Content-Type": "application/json",
            ...HEADERS,
          },
        });

        if (response.data.response_code === "0000") {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: `${response.data.response_description}`,
            confirmButtonColor: "#2D7D9F",
          }).then((result) => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed!",
            text: `${response.data.response_description}`,
            confirmButtonColor: "#2D7D9F",
          }).then((result) => {
            window.location.reload();
          });
        }
      }
    } catch (error) {
      Swal.fire("Error", "An error occurred. Please try again later.", "error");
    }
  };

  const tableData = RestrictedDate.map((resdate) => ({
    restricted_date: resdate.restricted_date,
    restricted_reason: resdate.restricted_reason,

    delete: (
      <FontAwesomeIcon
        style={{ cursor: "pointer" }}
        icon={faTrash}
        onClick={() => handleDelete(resdate.date_id)}
      />
    ),
  }));

  const tableColumns = [
    {
      accessorKey: "restricted_date",
      header: "Restricted Dates",
    },
    {
      accessorKey: "restricted_reason",
      header: "Reason",
    },
    {
      accessorKey: "delete",
      header: "Delete",
    },
  ];

  const paginatedData = tableData.slice(page * pageSize, (page + 1) * pageSize);
  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  const handlePageChange = (newPage) => setPage(newPage);

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };

  return (
    <div className="">
      <div>
        <span className="breadcrumb d-flex gap-2">
          <Link className="previou-link text-decoration-none" to="/leave-page">
            Leave Setting
          </Link>
          <span>/</span>
          <span className="current-link text-decoration-none">
            {" "}
            Restricted Date
          </span>
        </span>
      </div>

      <div className="headerSection">
        <span className="title">Restricted Date</span>
      </div>
      <div className="d-flex">
        <button className="ms-auto button-outline" onClick={Restricated_Date}>
          Add Date
        </button>
      </div>
      <div className="tab mt-3">
        <MantineReactTable
          columns={tableColumns}
          data={paginatedData}
          enablePagination={false}
          enableColumnFilters={true}
          enableSorting={true}
          enableColumnOrdering={true}
          enableGlobalFilter={true}
          enableRowSelection={false}
          enableFullScreenToggle={false}
          mantineTableBodyCellProps={{
            style: {
              backgroundColor: "#C8E3EC60",
              color: "#505050",
              border: "0.5px solid #fff",
              padding: "10px",
            },
          }}
          mantineTableHeadCellProps={{
            style: {
              backgroundColor: "#2d7d9f",
              fontSize: "14px",
              fontWeight: 500,
              color: "#fff",
              border: "1px solid #fff",
            },
          }}
          mantineTableBodyRowProps={(row) => ({
            style: {
              backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
            },
          })}
        />
        <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontSize: "14px" }}>Items per page:</span>
            <select
              className="form-select"
              style={{ width: "110px" }}
              value={pageSize}
              onChange={(e) => handlePageSizeChange(parseInt(e.target.value))}
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
              <option value={100}>100 rows</option>
            </select>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <span style={{ fontSize: "14px" }}>
              {totalRows === 0
                ? "Showing 0 to 0 of 0 entries"
                : `Showing ${startRow} - ${endRow} of ${totalRows} entries`}
            </span>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-3">
            <button
              className="previous-button"
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 0}
            >
              Previous
            </button>
            <button
              className="add-button text-center justify-content-center"
              style={{ width: "100px" }}
              onClick={() => handlePageChange(page + 1)}
              disabled={(page + 1) * pageSize >= tableData.length}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
